import React from 'react';
import { UserRoundIcon } from 'lucide-react';
export function About() {
  return <section id="acerca" className="scroll-mt-24 border-t border-white/8 bg-ink-900 py-20 lg:py-28" data-id="element-13" data-mp="2pr751624po1r">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-14" data-mp="2ttbvxx1706kp">
        <div className="grid items-center gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-15" data-mp="2trr3ccyfuxph">
          {/* Placeholder de foto — reemplaza por: <img src="/imagenes/yenni.jpg" alt="Yenni, fundadora de YenniDigital" className="h-full w-full object-cover" /> */}
          <div className="relative mx-auto w-full max-w-sm" data-id="element-16" data-mp="38pjgwzkfdc11">
            <div aria-hidden="true" className="pointer-events-none absolute -inset-4 rounded-3xl bg-neon/10 blur-[60px]" data-id="element-17" data-mp="38nzzh5n18uxo" />
            <div className="relative aspect-[4/5] overflow-hidden rounded-3xl border border-neon/60 bg-ink-800 shadow-glow" data-id="element-18" data-mp="3hi4wk6srf2ln">
              <img src="https://cdn.magicpatterns.com/uploads/we5juAigmtxLs7iemUn3z6/aboutYenni.webp" alt="Yenni, fundadora de YenniDigital" className="h-full w-full object-cover" loading="lazy" decoding="async" data-id="element-19" data-mp="3mfmyhd8d0hk5" />
            </div>
          </div>

          <div data-id="element-20" data-mp="2cq101rvwwl72">
            <div aria-hidden="true" className="h-px w-16 bg-neon/70" data-id="element-21" data-mp="2crkd79m9ug4m" />
            <h2 className="mt-6 text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-22" data-mp="27rpq7h5maaou">
              Conoce a la estratega detrás de YenniDigital
            </h2>
            <p className="mt-6 text-base leading-relaxed text-mist-muted" data-id="element-23" data-mp="30g3lhp5bmswp">
              Soy Yenni, creadora de YenniDigital. Ayudo a negocios en USA y Latinoamérica a tener
              una presencia digital profesional, moderna y enfocada en resultados. Mi enfoque
              combina diseño web, copy persuasivo, conexión a WhatsApp, formularios, redes sociales
              y estrategias digitales para que cada página no solo se vea bien, sino que también
              ayude a generar oportunidades reales de venta.
            </p>

            <blockquote className="mt-8 border-l-2 border-neon pl-5" data-id="element-24" data-mp="66vf94mqrz75">
              <p className="text-lg font-medium leading-relaxed text-white sm:text-xl" data-id="element-25" data-mp="b5gcqwam04rw">
                “Mi objetivo es que tu página web trabaje como una herramienta de ventas para tu
                negocio.”
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
}